/**
 * The archetypes that exist.
 *
 * One import and one entry each. `ZONE_ARCHETYPE_ORDER` is what any list of places to raid is
 * drawn in, and it is part of the determinism contract for the same reason `WEATHER_ORDER` is:
 * anything that picks a place walks it.
 */

import { FORTIFIED_BLOCK } from '@/sim/worldgen/archetypes/fortifiedBlock';
import { INDUSTRIAL_YARD } from '@/sim/worldgen/archetypes/industrialYard';
import { SUBURBAN_RUINS } from '@/sim/worldgen/archetypes/suburbanRuins';
import type { ZoneArchetype, ZoneArchetypeId } from '@/sim/worldgen/zoneArchetypeContract';

export const ZONE_ARCHETYPES = {
  suburbanRuins: SUBURBAN_RUINS,
  industrialYard: INDUSTRIAL_YARD,
  fortifiedBlock: FORTIFIED_BLOCK,
} as const satisfies Record<ZoneArchetypeId, ZoneArchetype>;

/** Presentation order, and part of the determinism contract. */
export const ZONE_ARCHETYPE_ORDER: readonly ZoneArchetypeId[] = [
  'suburbanRuins',
  'industrialYard',
  'fortifiedBlock',
];

export function zoneArchetype(id: ZoneArchetypeId): ZoneArchetype {
  return ZONE_ARCHETYPES[id];
}

export function isZoneArchetypeId(value: string): value is ZoneArchetypeId {
  return Object.hasOwn(ZONE_ARCHETYPES, value);
}
